export const GET_CURRENT_LOCATION="GET_CURRENT_LOCATION";
export const GET_CURRENT_WEATHER="GET_CURRENT_WEATHER";
export const GET_WEATHER_BY_LOCATION="GET_WEATHER_BY_LOCATION";
export const GET_LANGITUDE_OR_LATITUDE="GET_LANGITUDE_OR_LATITUDE";
// export const GET_LATITUDE="GET_LATITUDE";
export const GET_MAP="GET_MAP";
export const GET_ERROR="GET_ERROR";
export const GET_WEATHER_FORECAST="GET_WEATHER_FORECAST";
export const REQUEST_OF_DATA="REQUEST_OF_DATA";
export const SIGNIN_LOODING_REQUEST = 'SIGNIN_LOODING_REQUEST';
export const SIGNIN_SUCCESS_REQUEST = 'SIGNIN_SUCCESS_REQUEST';
export const SIGNIN_FAILURE_REQUEST = 'SIGNIN_FAILURE_REQUEST';
export const SIGNUP_LOODING_REQUEST = 'SIGNUP_LOODING_REQUEST';
export const SIGNUP_SUCCESS_REQUEST = 'SIGNUP_SUCCESS_REQUEST';
export const SIGNUP_FAILURE_REQUEST = 'SIGNUP_FAILURE_REQUEST';
export const SIGNOUT_REQUEST = 'SIGNOUT_REQUEST';